$(function () {
  const navTabs = document.querySelector('.nav-tabs');
  if (!navTabs) return;
  const navItems = navTabs.querySelectorAll('.nav-item');
  const hamburger = document.createElement('button');
  const dropdown = document.createElement('ul');

  hamburger.className = 'hamburger-menu btn btn-link';
  hamburger.setAttribute('data-bs-toggle', 'dropdown');
  hamburger.innerHTML = '<div><span></span><span></span><span></span></div>' + window.ifunds.strings.more;
  dropdown.className = 'dropdown-menu';

  navTabs.appendChild(hamburger);
  navTabs.appendChild(dropdown);

  function debounce(func: (...args: any[]) => void, wait: number) {
    let timeout: number;
    return function executedFunction(...args: any[]) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = window.setTimeout(later, wait);
    };
  }

  function createDropdownItem(item: HTMLElement) {
    const link = item.querySelector('.nav-link') as HTMLAnchorElement;
    const dropdownItem = document.createElement('a');
    dropdownItem.className = 'dropdown-item';
    dropdownItem.href = link.href;
    dropdownItem.textContent = link.textContent;
    if (link.classList.contains('active')) {
      dropdownItem.classList.add('active');
    }
    return dropdownItem;
  }

  function handleTabOverflow() {
    const navTabsRect = navTabs.getBoundingClientRect();
    const hamburgerWidth = 65; // Approximate width of hamburger menu
    let availableWidth = navTabsRect.width - hamburgerWidth;
    let hiddenItems = [];

    // Reset previous states
    navItems.forEach((item: HTMLElement) => item.style.display = 'block');
    dropdown.innerHTML = '';
    hamburger.classList.remove('active'); // Reset hamburger active state

    // Calculate which tabs to hide
    let currentWidth = 0;
    navItems.forEach((item: HTMLElement, index) => {
      const itemWidth = item.getBoundingClientRect().width;
      currentWidth += itemWidth;

      if (currentWidth > availableWidth && index > 0) {
        item.style.display = 'none';
        const dropdownItem = createDropdownItem(item);
        dropdown.appendChild(dropdownItem);
        hiddenItems.push(item);

        if (dropdownItem.classList.contains('active')) {
          hamburger.classList.add('active');
        }
      }
    });

    hamburger.style.display = hiddenItems.length > 0 ? 'flex' : 'none';
  }

  const debouncedHandleTabOverflow = debounce(handleTabOverflow, 10);

  const resizeObserver = new ResizeObserver(() => {
    debouncedHandleTabOverflow();
  });
  resizeObserver.observe(navTabs);

  handleTabOverflow();

  window.addEventListener('unload', () => {
    resizeObserver.disconnect();
  });
});